import React from "react";

export default function AboutPage() {
    return <h2>Система сотрудник</h2>;
}